module.exports = __webpack_public_path__ + "static/media/Citation_Set.40dcfc10.glb";